import {queries} from '@/shared/integrations/zero'
import {PrescribedName} from '@cypro/engine/schema'
import {useQuery, useSuspenseQuery} from '@rocicorp/zero/react'

export function useGetPrescribedName(id: string | undefined | null) {
  const [tradeName, meta] = useQuery(queries.products.getPrescribeNameById(id || ''))
  return [tradeName as unknown as PrescribedName, meta] as const
}

export function useSuspenseGetPrescribedName(id: string | undefined | null) {
  const [prescribedName, meta] = useSuspenseQuery(queries.products.getPrescribeNameById(id || ''))
  return [prescribedName as unknown as PrescribedName, meta] as const
}
